// import React, {lazy} from "react";
import { useNavigation, useRoutes } from "react-router-dom";
import { lazy, useContext } from "react";



const RootLayout = lazy(()=> import("../pages/root"))

const HomePage = lazy(()=> import("../pages/main/index"))
const PasswordReset = lazy(()=> import("../pages/user/password"))
const ReferenceCreate = lazy(()=> import("../pages/reference/create"))
const AccountValidated = lazy(()=> import("../pages/user/verified"))
const PaymentSuccess = lazy(()=> import("../pages/user/payment-sucess"))
const PrivacyScreen = lazy(()=> import("../pages/privacy/privacy"))
const TermsScreen = lazy(()=> import("../pages/terms/terms"))
const HeroFeaturesScreen = lazy(()=>import("../pages/main/heroFeaturesScreen"))
const FeaturedProductsScreen = lazy(()=>import('../pages/main/products'))
const AboutScreen = lazy(()=>import('../pages/main/about'))
const NotFoundPage = lazy(()=>import("../components/notFound"))


const AppRoutes = () => {

  const routes = [
    { 
      path : '/', 
      element : <RootLayout/>,
      children: [
        {index: true, element: <HomePage /> }, // correspond à `/`
        { path : '/home', index: true, element: <HomePage /> }, // correspond à `/`
        { path : '/features', element : <HeroFeaturesScreen/> },
        { path : '/products', element : <FeaturedProductsScreen/> },
        { path : '/about', element : <AboutScreen/> }
      ]
    },
    { path : '/reference/:token', element : <ReferenceCreate/>},
    { path : '/user/verified/:token', element : <AccountValidated/>},
    { path : '/user/payment/:id', element : <PaymentSuccess/>},
    { path : '/user/backup/:token', element : <PasswordReset/>},
    { path : '/privacy', element : <PrivacyScreen/>},
    { path : '/terms', element : <TermsScreen/>},
    { path : '*', element : <NotFoundPage/>},
  ];

  return useRoutes(routes); // On utilise useRoutes pour combiner les routes
};

export default AppRoutes;